import { Button, Center, Text } from "native-base";
import React from "react";
import { Linking } from "react-native";

import { TERMS_URL } from "@/config/constants";

const TermsButton = () => {
  const onOpenTerms = () => Linking.openURL(TERMS_URL);
  return (
    <Center py="6">
      <Text>Ao continuar você concordará com os</Text>
      <Button variant="ghost" p={0} onPress={() => onOpenTerms()}>
        Termos & Condições
      </Button>
    </Center>
  );
};

export default TermsButton;
